import axios from 'axios'

const apiHelper = axios.create({
  baseURL: 'https://web-ar-api.spe3d.co/api/v1/card-content'
})

export default {
  /**
   * @typedef Card
   * @property {string} name
   * @property {string} email
   * @property {string} phone
   * @property {number[]} [bought_product]
   * @property {string} card_content
   */

  /**
   * @param {Card} data
   */
  postCard(data) {
    return apiHelper.post('/', data)
  },
}